import { atomFamily, atomWithStorage } from "jotai/utils";
import { type TableGroupingType } from "./types";

export const selectedGroupingTypeAtomFamily = atomFamily(
    (orgUname: string | undefined) =>
        atomWithStorage<TableGroupingType>(
            `objectivesSelectedGroupingType_${orgUname}`,
            "none",
        ),
);